import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './help.css';

const Help = () => {
  const [openSections, setOpenSections] = useState({
    returnExchange: true,
    payment: true,
    delivery: true,
    faq: true,
  });

  const [openQuestions, setOpenQuestions] = useState({
    
    return: false,
    exchange: false,
    priceBlock: false,
    
    paymentSite: false,
    paymentMethods: false,
    priceUnit: false,
    
    deliveryMethods: false,
    deliveryCost: false,
    trackOrder: false,
    
    damagedProduct: false,
    cancelOrder: false,
    discounts: false,
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleQuestion = (question) => {
    setOpenQuestions((prev) => ({
      ...prev,
      [question]: !prev[question],
    }));
  };

  return (
    <div className="help-container">
      <Helmet>
        <title>Помощь | Nicotine Club</title>
        <meta
          name="description"
          content="Часто задаваемые вопросы, возврат и обмен, способы оплаты, доставка и акции в магазине Nicotine Club. Помощь покупателю."
        />
        <meta
          name="keywords"
          content="помощь, FAQ, возврат, обмен, оплата, доставка, акции, Nicotine Club"
        />
      </Helmet>

      {/* Секция: Возврат и обмен */}
      <div className="help-section">
        <h2 className="section-title" onClick={() => toggleSection('returnExchange')}>
          Возврат и обмен
          <span className={`icon ${openSections.returnExchange ? 'open' : ''}`}>
            {openSections.returnExchange ? '−' : '+'}
          </span>
        </h2>
        <div className={`questions ${openSections.returnExchange ? 'open' : ''}`}>
          <div className="question-item" onClick={() => toggleQuestion('return')}>
            <span className={`plus-icon ${openQuestions.return ? 'open' : ''}`}>
              {openQuestions.return ? '−' : '+'}
            </span>
            <span className="question-text">Могу ли я оформить возврат?</span>
          </div>
          <div className={`answer ${openQuestions.return ? 'open' : ''}`}>
            Да, вы можете оформить возврат товара в течение 30 дней с момента покупки. Для этого свяжитесь с нашей службой поддержки, и мы поможем вам с оформлением. Убедитесь, что товар сохранил свой первоначальный вид и упаковку.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('exchange')}>
            <span className={`plus-icon ${openQuestions.exchange ? 'open' : ''}`}>
              {openQuestions.exchange ? '−' : '+'}
            </span>
            <span className="question-text">Могу ли я обменять товар?</span>
          </div>
          <div className={`answer ${openQuestions.exchange ? 'open' : ''}`}>
            Обмен товара возможен при условии сохранения его товарного вида и потребительских свойств. Если товар вам не подошел, свяжитесь с нами, и мы предложим варианты обмена.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('priceBlock')}>
            <span className={`plus-icon ${openQuestions.priceBlock ? 'open' : ''}`}>
              {openQuestions.priceBlock ? '−' : '+'}
            </span>
            <span className="question-text">На сайте цена указана за штуку или коробку?</span>
          </div>
          <div className={`answer ${openQuestions.priceBlock ? 'open' : ''}`}>
            Цены на сайте указаны за блок сигарет. Один блок содержит 10 пачек. Если у вас есть вопросы по количеству, уточните у нашего менеджера перед оформлением заказа.
          </div>
        </div>
      </div>

      {/* Секция: Оплата */}
      <div className="help-section">
        <h2 className="section-title" onClick={() => toggleSection('payment')}>
          Оплата
          <span className={`icon ${openSections.payment ? 'open' : ''}`}>
            {openSections.payment ? '−' : '+'}
          </span>
        </h2>
        <div className={`questions ${openSections.payment ? 'open' : ''}`}>
          <div className="question-item" onClick={() => toggleQuestion('paymentSite')}>
            <span className={`plus-icon ${openQuestions.paymentSite ? 'open' : ''}`}>
              {openQuestions.paymentSite ? '−' : '+'}
            </span>
            <span className="question-text">Возможна ли оплата на сайте?</span>
          </div>
          <div className={`answer ${openQuestions.paymentSite ? 'open' : ''}`}>
            Да, оплата на сайте доступна через различные платежные системы. Мы гарантируем безопасность и конфиденциальность всех транзакций.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('paymentMethods')}>
            <span className={`plus-icon ${openQuestions.paymentMethods ? 'open' : ''}`}>
              {openQuestions.paymentMethods ? '−' : '+'}
            </span>
            <span className="question-text">Как я могу оплатить заказ?</span>
          </div>
          <div className={`answer ${openQuestions.paymentMethods ? 'open' : ''}`}>
            Вы можете оплатить заказ банковской картой (Visa, MasterCard, Мир), электронными кошельками (Qiwi, WebMoney, Яндекс.Деньги) или через банковский перевод.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('priceUnit')}>
            <span className={`plus-icon ${openQuestions.priceUnit ? 'open' : ''}`}>
              {openQuestions.priceUnit ? '−' : '+'}
            </span>
            <span className="question-text">На сайте цена указана за штуку или коробку?</span>
          </div>
          <div className={`answer ${openQuestions.priceUnit ? 'open' : ''}`}>
            Цены на сайте указаны за единицу товара, если не указано иное. Обратите внимание на описание товара.
          </div>
        </div>
      </div>

      {/* Секция: Доставка */}
      <div className="help-section">
        <h2 className="section-title" onClick={() => toggleSection('delivery')}>
          Доставка
          <span className={`icon ${openSections.delivery ? 'open' : ''}`}>
            {openSections.delivery ? '−' : '+'}
          </span>
        </h2>
        <div className={`questions ${openSections.delivery ? 'open' : ''}`}>
          <div className="question-item" onClick={() => toggleQuestion('deliveryMethods')}>
            <span className={`plus-icon ${openQuestions.deliveryMethods ? 'open' : ''}`}>
              {openQuestions.deliveryMethods ? '−' : '+'}
            </span>
            <span className="question-text">Какие способы доставки доступны?</span>
          </div>
          <div className={`answer ${openQuestions.deliveryMethods ? 'open' : ''}`}>
            Мы предлагаем несколько вариантов доставки: курьерская доставка по вашему адресу, самовывоз из нашего пункта выдачи и почтовая доставка по всей России.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('deliveryCost')}>
            <span className={`plus-icon ${openQuestions.deliveryCost ? 'open' : ''}`}>
              {openQuestions.deliveryCost ? '−' : '+'}
            </span>
            <span className="question-text">Сколько стоит доставка?</span>
          </div>
          <div className={`answer ${openQuestions.deliveryCost ? 'open' : ''}`}>
            Стоимость доставки зависит от вашего местоположения и выбранного способа. Подробную информацию уточняйте при оформлении заказа.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('trackOrder')}>
            <span className={`plus-icon ${openQuestions.trackOrder ? 'open' : ''}`}>
              {openQuestions.trackOrder ? '−' : '+'}
            </span>
            <span className="question-text">Как отследить заказ?</span>
          </div>
          <div className={`answer ${openQuestions.trackOrder ? 'open' : ''}`}>
            После отправки заказа вы получите трек-номер для отслеживания. Статус доставки можно проверить на сайте транспортной компании или связаться с нашей поддержкой.
          </div>
        </div>
      </div>

      {/* Секция: FAQ */}
      <div className="help-section">
        <h2 className="section-title" onClick={() => toggleSection('faq')}>
          Часто задаваемые вопросы (FAQ)
          <span className={`icon ${openSections.faq ? 'open' : ''}`}>
            {openSections.faq ? '−' : '+'}
          </span>
        </h2>
        <div className={`questions ${openSections.faq ? 'open' : ''}`}>
          <div className="question-item" onClick={() => toggleQuestion('damagedProduct')}>
            <span className={`plus-icon ${openQuestions.damagedProduct ? 'open' : ''}`}>
              {openQuestions.damagedProduct ? '−' : '+'}
            </span>
            <span className="question-text">Что делать, если товар поврежден?</span>
          </div>
          <div className={`answer ${openQuestions.damagedProduct ? 'open' : ''}`}>
            Если вы получили товар с повреждениями, свяжитесь с нашей службой поддержки в течение 24 часов с момента получения. Мы организуем замену или возврат средств.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('cancelOrder')}>
            <span className={`plus-icon ${openQuestions.cancelOrder ? 'open' : ''}`}>
              {openQuestions.cancelOrder ? '−' : '+'}
            </span>
            <span className="question-text">Могу ли я отменить заказ?</span>
          </div>
          <div className={`answer ${openQuestions.cancelOrder ? 'open' : ''}`}>
            Да, вы можете отменить заказ до момента его отправки. Для этого свяжитесь с нами по телефону или через онлайн-чат.
          </div>

          <div className="question-item" onClick={() => toggleQuestion('discounts')}>
            <span className={`plus-icon ${openQuestions.discounts ? 'open' : ''}`}>
              {openQuestions.discounts ? '−' : '+'}
            </span>
            <span className="question-text">Есть ли у вас акции или скидки?</span>
          </div>
          <div className={`answer ${openQuestions.discounts ? 'open' : ''}`}>
            Да, мы регулярно проводим акции и предлагаем скидки для наших клиентов. Следите за обновлениями на сайте или подпишитесь на нашу рассылку, чтобы быть в курсе выгодных предложений.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
